import React, { Component } from 'react';
import styled from 'styled-components';
import { Transition } from 'transition-group';

import ModalSwitcher from '../ModalSwitcher/index';
import { Screen } from 'components/Common';
import { Page } from 'components/v2/Common';
import { BackLink } from '../Navigation/BackLink';
import { AutomationText } from '../Automation';
import { ShareAppButton } from '../ShareApp/index';
import Typography from '../Typography';

import { isiOS } from 'config';
import { AppType } from '../../../constants';

const HeaderDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 64px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--sys-color--surface);
  color: var(--sys-color--on-surface);
  border-bottom: 1px solid ${({ theme }) => theme.borderColorV2 || '#E7E9EA'};
`;

const BackDiv = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

const Title = styled(Typography)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 60%;
`;

const ShareDiv = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

interface LayoutProps {
  tabs?: number;
  pageElement?: React.ReactChild;
  direction?: string;
  name?: string;
  scrollKey?: string;
  center?: string;
  app?: any
}

export default class Layout extends Component<LayoutProps> {
  state = {
    scrolling: false,
    top: 0
  };

  onScroll = ({ scrolling = false, top = 0 }) => {
    if (isiOS && this.state.scrolling === scrolling) {
      return;
    }
    if (top > 64) {
      top = 64;
    }
    if (this.state.scrolling === scrolling && this.state.top === top) {
      return;
    }
    this.setState({
      scrolling,
      top
    });
  };

  render() {
    const {
      tabs,
      pageElement,
      direction,
      name,
      scrollKey,
      center,
      app
    } = this.props;
    const { top } = this.state;

    const navbarHeight = '64px';
    let savedNavigator = (window.navigator as any);

    let NavigationEl = (
      <HeaderDiv>
        <BackDiv>
          <BackLink />
        </BackDiv>
        { center &&
          <Title variant="titleLarge" className="permissions-title-v2" aria-label="permissions-title" id="permissions-title">{center}</Title>
        }
        { isiOS && app && !app.isPrivate && app.type.toLocaleLowerCase() !== AppType.TILE && savedNavigator.share &&
          <ShareDiv>
            <ShareAppButton id={"share-app-button"} app={app} paddingTop={true}/>
            <AutomationText/>
          </ShareDiv>}
      </HeaderDiv>
    );

    let PageEl = (
      <Page
        onScroll={this.onScroll}
        navbarHeight={navbarHeight}
        scrollKey={scrollKey}
      >
        {pageElement}
      </Page>
    );

    if (isiOS && direction !== 'slide-left' && direction !== 'slide-right') {
      NavigationEl = (
        <Transition key={`${name}-nav`} className={`nav-${direction}`}>
          {NavigationEl}
        </Transition>
      );
      PageEl = (
        <Transition key={`${name}-page`} className={direction}>
          {PageEl}
        </Transition>
      );
    }

    return (
      <Screen className="screen v2-top-bar">
        <ModalSwitcher />
        {NavigationEl}
        {PageEl}
      </Screen>
    );
  }
}
